// react
// dependencies
import Fuse from "fuse.js";
import { Map } from "immutable";

// constants
import FUSE_OPTIONS from "../constants/FuzzySearchOptions";

const initialState = Map({
	all: new Fuse([], FUSE_OPTIONS),
});

export default function autocomplete(state = initialState, action) {
	switch (action.type) {
		case "HASHTAGS:PARSEHASHTAGS":
			window.__INTERNALOBJECTS_HASHTAGS = action.all; // eslint-disable-line no-underscore-dangle
			return state.setIn(["all"], action.all);

		default:
			// never forget your default return state!
			return state;
	}
}
